import { gql } from "@apollo/client"

export const GET_SESSIONS_BY_FREQ = gql`
query GetSessionByGroup($searchCriteria:String!,$searchId:UUID, $sessionType:SessionScreenType,$frequency:GroupingType!){
  sessionsByFrequency (searchCriteria: $searchCriteria,searchId:$searchId,sessionType: $sessionType, frequency:$frequency) {
    total
    year
    month
    week
    day
    start
    sessions{
      id
      personId
      createdAt
      type
      category
      data
      status
      checkpoint {
        current {
          name
        }
      }
    }
    
  }
}`